import React from 'react';
import {
	AlertConfirm, BasicButton, MenuSuperiorTabs, TextInput
} from '../../UI';
import { getSecondary } from '../../styles/colors';
import FormRootLayout from './FormRootLayout';
import RichTextInput from '../../UI/RichTextInput';
import ModalTranslate from './ModalTranslate';

const ConfigEmails = ({
	portal,
	updateState,
	translate,

}) => {
	const [localState, setLocalState] = React.useState(portal.config);
	const [selecteOptionMenu, setSelecteOptionMenu] = React.useState('Asistencia a la junta');
	const [modalEmail, setModalEmail] = React.useState(false);
	const emails = localState?.emails;
	const checkValidEmail = email => {
		const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email) && !/\'|\"|\\|\//.test(email);
	};
	function validateEmail() {
		setModalEmail(false);
		let validFormatEmail = true;
		Object.entries(emails).forEach(i => {
			Object.entries(i[1]).forEach(j => {
				Object.entries(j[1].for).forEach(k => {
					if (k[1] !== '' && checkValidEmail(k[1]) === false) {
						setModalEmail(true);
						validFormatEmail = false;
					}
				});
			});
		});
		if (validFormatEmail) {
			updateState({
				...localState
			});
		}
	}


	const renderNavBar = () => {
		const tabs = [];

		const { sections } = portal.config;

		if (sections.access.isActive) {
			tabs.push('Asistencia a la junta');
		}

		if (sections.delegation.isActive) {
			tabs.push('Delegación');
		}

		if (sections.earlyVote.isActive) {
			tabs.push('Voto telemático');
		}

		if (sections.interventions.isActive) {
			tabs.push('Intervenciones');
		}
		tabs.push('Solicitud Rechazada');

		return (
			<div style={{ marginTop: '1em' }}>
				<div style={{
					display: 'flex',
					padding: '1em',
					justifyContent: 'space-between',
					paddingTop: '0px',
					alignItems: 'center',
					paddingLeft: '0'
				}}>
					<div style={{ fontSize: '13px' }}>
						<MenuSuperiorTabs
							items={tabs}
							setSelect={setSelecteOptionMenu}
							selected={selecteOptionMenu}
							colorSelected={'#000000'}
						/>
					</div>
				</div>
			</div>
		);
	};
	const renderForm = () => (
		<div>
			<div style={{ marginBottom: '1em', color: 'black' }}>
				<div>
					{renderNavBar()}
				</div>
				{selecteOptionMenu === 'Asistencia a la junta' &&
					<div>
						<div style={{ marginBottom: '1em' }}>
							<b>Asistencia a la junta</b>
						</div>
						<div>
							<div style={{ textDecorationLine: 'underline', marginBottom: '1em' }}>Email enviado a root:</div>
							<EmailForm
								isRoot={true}
								translate={translate}
								clave={'access'}
								toSend={'internal'}
								localState={localState}
								setLocalState={setLocalState}
								modalEmail={modalEmail}
								setModalEmail={setModalEmail}
							/>
							<hr style={{ marginBottom: '1em' }}></hr>
							<div style={{ textDecorationLine: 'underline', marginBottom: '1em' }}>Email enviado a cliente:</div>
							<EmailForm
								translate={translate}
								clave={'access'}
								toSend={'external'}
								localState={localState}
								setLocalState={setLocalState}
								modalEmail={modalEmail}
								setModalEmail={setModalEmail}
							/>
						</div>
					</div>
				}
				{selecteOptionMenu === 'Delegación' &&
					<div>
						<div style={{ marginBottom: '1em' }}>
							<b>Delegación</b>
						</div>
						<div>
							<div style={{ textDecorationLine: 'underline', marginBottom: '1em' }}>Email enviado a root:</div>
							<EmailForm
								isRoot={true}
								translate={translate}
								clave={'delegation'}
								toSend={'internal'}
								localState={localState}
								setLocalState={setLocalState}
								modalEmail={modalEmail}
								setModalEmail={setModalEmail}
							/>
							<hr style={{ marginBottom: '1em' }}></hr>
							<div style={{ textDecorationLine: 'underline', marginBottom: '1em' }}>Email enviado a cliente:</div>
							<EmailForm
								translate={translate}
								clave={'delegation'}
								toSend={'external'}
								localState={localState}
								setLocalState={setLocalState}
								modalEmail={modalEmail}
								setModalEmail={setModalEmail}
							/>
						</div>
					</div>
				}
				{selecteOptionMenu === 'Voto telemático'
					&& <div>
						<div style={{ marginBottom: '1em' }}>
							<b>Voto telemático</b>
						</div>
						<div>
							<div style={{ textDecorationLine: 'underline', marginBottom: '1em' }}>Email enviado a root:</div>
							<EmailForm
								isRoot={true}
								translate={translate}
								clave={'earlyVote'}
								toSend={'internal'}
								localState={localState}
								setLocalState={setLocalState}
								modalEmail={modalEmail}
								setModalEmail={setModalEmail}
							/>
							<hr style={{ marginBottom: '1em' }}></hr>
							<div style={{ textDecorationLine: 'underline', marginBottom: '1em' }}>Email enviado a cliente:</div>
							<EmailForm
								translate={translate}
								clave={'earlyVote'}
								toSend={'external'}
								localState={localState}
								setLocalState={setLocalState}
								modalEmail={modalEmail}
								setModalEmail={setModalEmail}
							/>
						</div>
					</div>
				}
				{selecteOptionMenu === 'Intervenciones'
					&& <div>
						<div style={{ marginBottom: '1em' }}>
							<b>Intervenciones</b>
						</div>
						<div>
							<div style={{ textDecorationLine: 'underline', marginBottom: '1em' }}>Email enviado a root:</div>
							<EmailForm
								isRoot={true}
								translate={translate}
								clave={'interventions'}
								toSend={'internal'}
								localState={localState}
								setLocalState={setLocalState}
								modalEmail={modalEmail}
								setModalEmail={setModalEmail}
							/>
							<hr style={{ marginBottom: '1em' }}></hr>
							<div style={{ textDecorationLine: 'underline', marginBottom: '1em' }}>Email enviado a cliente:</div>
							<EmailForm
								translate={translate}
								clave={'interventions'}
								toSend={'external'}
								localState={localState}
								setLocalState={setLocalState}
								modalEmail={modalEmail}
								setModalEmail={setModalEmail}
							/>
						</div>
					</div>
				}
				{selecteOptionMenu === 'Solicitud Rechazada' &&
					<div>
						<div style={{ marginBottom: '1em' }}>
							<b>Solicitud Rechazada</b>
						</div>
						<div>
							<div style={{ textDecorationLine: 'underline', marginBottom: '1em' }}>Email enviado a cliente:</div>
							<EmailForm
								translate={translate}
								clave={'rejectedRequest'}
								toSend={'external'}
								localState={localState}
								setLocalState={setLocalState}
								isRejectedRequest={true}
								modalEmail={modalEmail}
								setModalEmail={setModalEmail}
							/>
						</div>
					</div>
				}
			</div>
		</div >
	);


	return (
		<FormRootLayout
			form={renderForm()}
			button={
				<BasicButton
					color='white'
					text={translate.save}
					onClick={() => {
						validateEmail();
					}}
					backgroundColor={{
						backgroundColor: getSecondary(),
						border: `1px solid ${getSecondary()}`,
						boxShadow: 'none',
						color: 'white',
						fontWeight: 'bold'
					}}
				/>
			}
		/>
	);
};

const EmailForm = ({
	isRoot,
	translate,
	clave,
	toSend,
	localState,
	setLocalState,
	isRejectedRequest,
	setModalEmail,
	modalEmail,
}) => {
	if (!localState.emails) {
		return (<div>Los emails en esta versión no se pueden modificar</div>);
	}
	return (
		<div>
			{modalEmail &&
				<AlertConfirm
					acceptAction={() => setModalEmail(false)}
					open={modalEmail}
					buttonAccept={translate.accept}
					bodyText={
						<div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
							<span>
								Alguno de los formatos de email no es válido.
							</span>
						</div>
					}
					title={translate.confirm}
				/>
			}
			{!isRejectedRequest &&
				<div style={{ display: 'flex', alignItems: 'center', marginBottom: '2em' }}>
					<div style={{ width: '200px' }}>Para</div>
					<div style={{ width: '100%' }}>
						<TextInput
							value={localState.emails[clave][toSend].for.join()}
							disableUnderline={true}
							stylesTextField={{ marginBottom: '0' }}
							styleInInput={{
								marginBottom: '0',
								border: '1px solid #7e8993',
								paddingLeft: '5px',
								paddingRigth: '5px',
								borderRadius: '4px'
							}}
							labelNone={true}
							onChange={newData => setLocalState({
								...localState,
								emails: {
									...localState.emails,
									[clave]: {
										...localState.emails[clave],
										[toSend]: {
											...localState.emails[clave][toSend],
											for: newData.nativeEvent.target.value.split(','),
										}
									}
								}
							})}
						/>
					</div>
				</div>
			}
			{!isRoot &&
				<div>
					<div style={{ display: 'flex', alignItems: 'center', marginBottom: '2em' }}>
						<div style={{ width: '200px' }}>Asunto</div>
						<div style={{ width: 'calc( 100% - 145px )', marginRight: '20px' }}>
							<TextInput
								value={localState.emails[clave][toSend].subject.text.es}
								disableUnderline={true}
								stylesTextField={{ marginBottom: '0' }}
								styleInInput={{
									marginBottom: '0',
									border: '1px solid #7e8993',
									paddingLeft: '5px',
									paddingRigth: '5px',
									borderRadius: '4px'
								}}
								labelNone={true}
								onChange={newData => setLocalState({
									...localState,
									emails: {
										...localState.emails,
										[clave]: {
											...localState.emails[clave],
											[toSend]: {
												...localState.emails[clave][toSend],
												subject: {
													...localState.emails[clave][toSend].subject,
													text: {
														...localState.emails[clave][toSend].subject.text,
														es: newData.nativeEvent.target.value,
													}
												}
											}
										}
									}
								})}
							/>
						</div>
						<div>
							<ModalTranslate
								translate={translate}
								item={localState.emails[clave][toSend].subject}
								name={'Asunto'}
								stylesButton={{ width: '100px' }}
								textButton={'Traducción'}
								setLocalState={newData => setLocalState({
									...localState,
									emails: {
										...localState.emails,
										[clave]: {
											...localState.emails[clave],
											[toSend]: {
												...localState.emails[clave][toSend],
												subject: {
													...localState.emails[clave][toSend].subject,
													...newData
												}
											}
										}
									}
								})}
							/>
						</div>
					</div>
					<div style={{ display: 'flex', marginBottom: '1em' }}>
						<div style={{ width: '200px' }}>Cuerpo del mensaje</div>
						<div style={{ width: 'calc( 100% - 145px )', marginRight: '20px', height: '200px' }}>
							<RichTextInput
								value={localState.emails[clave][toSend].body.text.es}
								stylesQuill={{ height: '100%' }}
								onChange={newData => setLocalState({
									...localState,
									emails: {
										...localState.emails,
										[clave]: {
											...localState.emails[clave],
											[toSend]: {
												...localState.emails[clave][toSend],
												body: {
													...localState.emails[clave][toSend].body,
													text: {
														...localState.emails[clave][toSend].body.text,
														es: newData,
													}
												}
											}
										}
									}
								})}
							/>
						</div>
						<div>
							<ModalTranslate
								translate={translate}
								item={localState.emails[clave][toSend].body}
								name={'Cuerpo del mensaje'}
								stylesButton={{ width: '100px' }}
								textButton={'Traducción'}
								setLocalState={newData => setLocalState({
									...localState,
									emails: {
										...localState.emails,
										[clave]: {
											...localState.emails[clave],
											[toSend]: {
												...localState.emails[clave][toSend],
												body: {
													...localState.emails[clave][toSend].body,
													...newData
												}
											}
										}
									}
								})}
							/>
						</div>
					</div>
				</div>
			}
		</div>
	);
};

export default ConfigEmails;
